import '@material-design-icons/font/round.css';
import type { VuetifyOptions } from 'vuetify';
import 'vuetify/styles';

const getVuetifyConfig = (options?: {
    theme?: boolean;
}): VuetifyOptions => {
    const _options = options ?? {
        theme: false,
    };

    return {
        theme: _options.theme ? {} : false,
        defaults: {
            VBtnPrimary: {
                VProgressCircular: {
                    size: '24',
                },
            },
            VDataTable: {
                class: 'border rounded bg-background',
                sortAscIcon: 'arrow_drop_up',
                sortDescIcon: 'arrow_drop_down',
            },
            VProgressCircular: {
                size: '64',
            },
        },
    };
};

export { getVuetifyConfig };
